import {SidebarSection} from './SidebarSection'
import styles from './Reviewers.module.css'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'

const PLACEHOLDER_ROWS = 3

/** Loading skeleton that mirrors the Reviewers sidebar section */
export function ReviewersSkeleton() {
  return (
    <SidebarSection title="Reviewers">
      <ul className={styles.reviewerList}>
        {Array.from({length: PLACEHOLDER_ROWS}, (_, i) => (
          <li key={i} className={styles.reviewerRow}>
            <SkeletonBox className={styles.avatar} />
            <SkeletonText size="bodySmall" className={styles.name} />
            <SkeletonBox className={styles.indicator} />
          </li>
        ))}
      </ul>
    </SidebarSection>
  )
}
